import { render } from "./sti-need-to-sti-reverse-scan.vue?vue&type=template&id=726cac3a&scoped=true&ts=true"
import script from "./sti-need-to-sti-reverse-scan.vue?vue&type=script&lang=ts"
export * from "./sti-need-to-sti-reverse-scan.vue?vue&type=script&lang=ts"

import "./sti-need-to-sti-reverse-scan.vue?vue&type=style&index=0&id=726cac3a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726cac3a"]])

export default __exports__